import axios from "axios";  // ✅ ES module import
const api = `${process.env.REACT_APP_API_URL}/api/v1/user/`;

// Options
export async function Options() {
  try {
    const response = await axios.get(`${api}options`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
